import { useFrameDataStore } from "@/store/frameDataStore";
import { send_message_getFrameDataByTimeInterval } from '@/utils/wsWorkerEx';
import { getVehicleRecordMiss } from "@/service/index"

//该文件，用来实现分片获取数据，并能响应开始下载时间的变化；
export let params = {
  vehicleName: '',
  start_target: 0,//目标开始时间
  end_target: 0,//目标结束时间
  stepList: [{ start: 0, end: 0, state: 0, time: 0, ws: null }],//把时间区间拆分成多段。 state=0 未开始，=1 下载中  =2 下载完成；  
  downTimer: 0,  //下载数据的定时器
}

let congif = {
  stepTime: 50,//分片的大小，秒为单位  
  thread: 5,
}

let frameDataStore = {}


/**
 * 开始下载数据
 * @param {*} vehicleName  
 * @param {*} start   毫秒
 * @param {*} end     毫秒
 */
export async function downLoadData(vehicleName = "", start, end, origin, currentTime) {
  frameDataStore = useFrameDataStore();
  //开始下载数据
  //1. 清理之前的缓存参数；
  initParams(vehicleName, start, end);
  //2. 拆分时间区间
  buildStep(start, end, currentTime);
  //load数据文件：
  //3. load文件api的调用；
  //wswsws
  let res = await getVehicleRecordMiss(vehicleName, start, origin);
  //4. 启动一个ws，开始下载第一段数据
  getDataTime(origin);
  //wswsws
  return res.data;
}


function initParams(vehicleName = "", start, end) {
  params.stepList.forEach(item => {
    if (item.ws) {
      item.ws.close();
    }
  })
  clearInterval(params.downTimer);
  params = {
    vehicleName,
    start_target: start,//目标开始时间
    end_target: end,//目标结束时间
    stepList: [],//
    downTimer: 0,
  }
}


/**
 * 把要下载的时间段，按照step 分割成多个。 [{ start: 0, end: 0, state: 0, time: 0 }]
 * @param {*} params 
 */
function buildStep(start, end, currentTime) {
  {
    let step = start + congif.stepTime * 1000
    while (step < currentTime) {
      params.stepList.push({ start, end: step, state: 0, time: 0, ws: null });
      start = step + 1;
      step = start + congif.stepTime * 1000
    }
    if (start < currentTime) {
      params.stepList.push({ start, end: currentTime - 1, state: 0, time: 0, ws: null });
    }
  }
  {
    let step = currentTime + congif.stepTime * 1000
    let start=currentTime;
    while (step <= end) {
      params.stepList.push({ start, end: step, state: 0, time: 0, ws: null });
      start = step + 1;
      step = start + congif.stepTime * 1000
    }
    if (start < end) {
      params.stepList.push({ start, end, state: 0, time: 0, ws: null });
    }
  }
}
/**
 * 开始获取数据
 */
function getDataTime(origin) {
  clearInterval(params.downTimer);
  params.downTimer = setInterval(() => {
    let stepIndex = params.stepList.findIndex(e => e.start <= frameDataStore.currentTime && e.end >= frameDataStore.currentTime)
    if (stepIndex >= 0) {
      if (params.stepList[stepIndex].state == 0) {
        params.stepList[stepIndex].state = 1;
        params.stepList[stepIndex].ws = send_message_getFrameDataByTimeInterval(origin, params.vehicleName, params.stepList[stepIndex].start, params.stepList[stepIndex].end, handlerOver, true);
      } else if (params.stepList[stepIndex].state == 1) {
        //正在下载
        params.stepList[stepIndex].time += 1;//下载中 等待一帧。 
        if (params.stepList[stepIndex].time > 10 * 10) {
          params.stepList[stepIndex].state = 3;
        }
      } else {
        let count_all_ing = params.stepList.filter(e => e.state == 1).length;//后面正在下载的数量
        if (count_all_ing >= congif.thread) {
          return;
        }
        let count_next_ing = params.stepList.filter(e => e.state == 1 && e.start >= frameDataStore.currentTime).length;//后面正在下载的数量
        while (count_next_ing < congif.thread / 2) {
          if (downloadFrameData_next(origin) < 0) {
            if (downloadFrameData_per(origin) < 0) {
              break;
            }
          }
          count_next_ing++;
        }
        let count_per_ing = params.stepList.filter(e => e.state == 1 && e.end <= frameDataStore.currentTime).length;//后面正在下载的数量
        while (count_per_ing < congif.thread / 2) {
          if (downloadFrameData_per(origin) < 0) {
            if (downloadFrameData_next(origin) < 0) {
              break;
            }
          }
          count_per_ing++;
        }

        let count_over = params.stepList.filter(e => e.state != 2).length;//后面正在下载的数量
        if (count_over < 1) {
          clearInterval(params.downTimer);
        }
      }
    } else {
      clearInterval(params.downTimer);
    }
  }, 100);
}

function handlerOver(vehicleName, startTs, endTs) {
  let step = params.stepList.find(e => params.vehicleName == vehicleName && e.start == startTs && e.end == endTs);
  if (step) {
    step.state = 2;
  }
}

/**
 * 优先下载后面的
 * @returns 
 */
function downloadFrameData_next(origin) {
  let index_next = params.stepList.findIndex(e => e.state == 0 && e.start >= frameDataStore.currentTime);
  if (index_next >= 0) {
    params.stepList[index_next].state = 1;
    params.stepList[index_next].ws = send_message_getFrameDataByTimeInterval(origin, params.vehicleName, params.stepList[index_next].start, params.stepList[index_next].end, handlerOver);
    return index_next;
  } else {
    return -1
  }
}
/**
 * 优先下载前面的
 * @returns 
 */
function downloadFrameData_per(origin) {
  let index_next = params.stepList.findLastIndex(e => e.state == 0 && e.end <= frameDataStore.currentTime);
  if (index_next >= 0) {
    params.stepList[index_next].state = 1;
    params.stepList[index_next].ws = send_message_getFrameDataByTimeInterval(origin, params.vehicleName, params.stepList[index_next].start, params.stepList[index_next].end, handlerOver);
    return index_next;
  } else {
    return -1;
  }
}



